import $ from "jquery"
import ReportEditConfigController from './ATReportEditConfigController'
import ProfitLossDisplayedDataSelector from '../ProfitLossDisplayedDataSelector'

export default class ProfitLossReportEditConfigController extends ReportEditConfigController {}

ProfitLossReportEditConfigController.prototype.init = function ( config )
{
    ReportEditConfigController.prototype.init.call(this, config);
    
    var self = this;
    var reportParameters = this.makeReportParamsAccordingToFeatures( config.reportParameters );
    
    this.configChangedCallback = config.changeCallback;
    var configChanged = function () { self.configChanged(); };
    this.timeFormatSelector = this.initTimeFormatSelector(reportParameters.timeFormat, configChanged);
    this.cpSelector = this.makeCPSelector(reportParameters.customersProjectsSelection);

    this.showSpentTimeCheckbox = $("#showSpentTime");
    this.showSpentTimeCheckbox.prop("checked", reportParameters.showSpentTime);
    this.showSpentTimeCheckbox.on("change", configChanged);
    this.showAverageRatesCheckbox = $("#showAverageRates");
    this.showAverageRatesCheckbox.prop("checked", reportParameters.showAverageRates);
    this.showAverageRatesCheckbox.on("change", configChanged);
    
    if( EnabledFeatures.LVT || reportParameters.showLeaveTimeCosts )
    {
        $("#leaveTimeCosts").show();
        $("#generalCostsConfigSection").show();
        this.showLeaveTimeCostsChexbox = $( "#showLeaves" );
        this.showLeaveTimeCostsChexbox.prop("checked", reportParameters.showLeaveTimeCosts);
        this.showLeaveTimeCostsChexbox.on("change", configChanged);
    }
    
    if( EnabledFeatures.OVR || reportParameters.showOvertimeAddition )
    {
        $("#overtimeAddition").show();
        $("#generalCostsConfigSection").show();
        this.showOvertimeChexbox = $("#showOvertime");
        this.showOvertimeChexbox.prop("checked", reportParameters.showOvertimeAddition);
        this.showOvertimeChexbox.on("change", configChanged);
    }
    
    this.displayedDataSelector = new ProfitLossDisplayedDataSelector().init(
        "profitLossReportColumnsButton",
        reportParameters.firstGroupingLevel,
        reportParameters.secondGroupingLevel,
        reportParameters.thirdGroupingLevel,
        configChanged
    )
    return this;
};

ProfitLossReportEditConfigController.prototype.getConfig = function () {
    var groupingLevels = this.displayedDataSelector.getValue();
    return {
        timeFormat: this.timeFormatSelector.getValue(),
        showSpentTime: this.showSpentTimeCheckbox.is(":checked"),
        showAverageRates: this.showAverageRatesCheckbox.is(":checked"),
        showLeaveTimeCosts: !!this.showLeaveTimeCostsChexbox && this.showLeaveTimeCostsChexbox.is(":checked"),
        showOvertimeAddition: !!this.showOvertimeChexbox && this.showOvertimeChexbox.is(":checked"),
        firstGroupingLevel: groupingLevels.firstGroupingLevel,
        secondGroupingLevel: groupingLevels.secondGroupingLevel,
        thirdGroupingLevel: groupingLevels.thirdGroupingLevel,
        customersProjectsSelection: this.cpSelector.getCpSelection()
    };
};

ProfitLossReportEditConfigController.prototype.resetConfig = function () {
    this.timeFormatSelector.setActiveItemByValue(this.initReportParameters.timeFormat, true);
    this.showSpentTimeCheckbox.prop("checked", this.initReportParameters.showSpentTime);
    this.showAverageRatesCheckbox.prop("checked", this.initReportParameters.showAverageRates);
    if(this.showLeaveTimeCostsChexbox)
        this.showLeaveTimeCostsChexbox.prop("checked", this.initReportParameters.showLeaveTimeCosts);
    if(this.showOvertimeChexbox)
        this.showOvertimeChexbox.prop("checked", this.initReportParameters.showOvertimeAddition);
    this.displayedDataSelector.setValue(this.initReportParameters.firstGroupingLevel,
                                        this.initReportParameters.secondGroupingLevel,
                                        this.initReportParameters.thirdGroupingLevel);
    this.cpSelector.setSelection(this.initReportParameters.customersProjectsSelection);
};

ProfitLossReportEditConfigController.prototype.validate = function ()
{
    this.errors = [];

    if (!this.cpSelector.checkSelected())
        this.errors.push( this.possibleErrors.ERROR_EMPTY_CP_SELECTION );

    return this.errors.length == 0;
};

ProfitLossReportEditConfigController.prototype.initErrorsToSectionElsMap = function()
{
    var errorsToSectionElsMap = {};
    errorsToSectionElsMap[this.possibleErrors.ERROR_EMPTY_CP_SELECTION] = this.panelEl.find( "#cpSelectorId" );
    return errorsToSectionElsMap;
};


ProfitLossReportEditConfigController.prototype.setSelectorsInitStateFromCurrent = function () {
    ReportEditConfigController.prototype.setSelectorsInitStateFromCurrent.call(this);

    if(this.cpSelector) {
        this.cpSelector.setInitialValueFromCurrent();
    }
};



// WEBPACK FOOTER //
// ./web/js/reports/edit_config_controller/ProfitLossReportEditConfigController.js